export const stepTypes = {
  COMPANY_DETAILS: 'COMPANY_DETAILS',
  CREATE_LEAD: 'CREATE_LEAD',
  CREATE_POLICY: 'CREATE_POLICY',
  CREATE_POLICY_SERVICE: 'CREATE_POLICY_SERVICE',
  ADD_POLICIES_TOOLTIP: 'ADD_POLICIES_TOOLTIP',
  ADD_POLICY: 'ADD_POLICY',
  PREVIEW_APP_TOOLTIP: 'PREVIEW_APP_TOOLTIP',
  ACTIVATE_PLAN: 'ACTIVATE_PLAN',
  SELECT_POLICY_TOOLTIP: 'SELECT_POLICY_TOOLTIP',
  SHARE_OPTIONS_TOOLTIP: 'SHARE_OPTIONS_TOOLTIP',
  CHOOSE_HUB: 'CHOOSE_HUB',
};
export const stepsList = [
  stepTypes.COMPANY_DETAILS,
  stepTypes.CREATE_POLICY,
  stepTypes.CREATE_POLICY_SERVICE,
  stepTypes.PREVIEW_APP_TOOLTIP,
];

export const salesHubStepsList = [
  stepTypes.COMPANY_DETAILS,
  stepTypes.CREATE_LEAD,
];

export const bothHubsStepsListSalesFirst = [
  stepTypes.COMPANY_DETAILS,
  stepTypes.CHOOSE_HUB,
  stepTypes.CREATE_LEAD,
  stepTypes.CREATE_POLICY,
  stepTypes.CREATE_POLICY_SERVICE,
  stepTypes.PREVIEW_APP_TOOLTIP,
];

export const bothHubsStepsListServiceFirst = [
  stepTypes.COMPANY_DETAILS,
  stepTypes.CHOOSE_HUB,
  stepTypes.CREATE_POLICY,
  stepTypes.CREATE_POLICY_SERVICE,
  stepTypes.PREVIEW_APP_TOOLTIP,
  stepTypes.CREATE_LEAD,
];
